export default __webpack_public_path__ + "static/yoga-10-4de4e7da97a1ce09a8d11f28cc56bb91.png";